module.exports = __webpack_public_path__ + "static/media/perfil.c8bfb9dc.jpg";